import axios from 'axios';

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'https://satvicpath-backend.onrender.com'
});
// const API = axios.create({
//   baseURL: 'http://localhost:4000/'
// });

export default API;